import './Event.scss';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from 'react-plotly.js';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import io from 'socket.io-client';
import { TokenService } from '../../../services/token.service';
import { GristEvent, SNInfo, AOAEpochInfo, TDOAEpochInfo, OrbitInfo } from '../../../util/model';
//import { DataName, GristEvent, SNEventInfo, AOAInfo, TDOAInfo } from '../../../util/model';
import { actionUpdateLayerData } from '../../../redux/action/layerData';
import { RestApi } from '../../../services/restapi.service';
import Moment from "moment";
import { activityStatusAction } from "../../../redux/action/activity";
import {Viewer} from 'cesium';
import CesiumViewer from './cesium-components/cesiumviewer/CesiumViewer';
import MapInfo from './cesium-components/mapinfo/MapInfo';
import Compass from './cesium-components/compass/Compass';
import SNSymbol from './cesium-components/sn/SNSymbol';
import SNLabel from './cesium-components/sn/SNLabel';
import AOA from './cesium-components/aoa/AOA';
import TDOA from './cesium-components/tdoa/TDOA';
import SolSymbol from './cesium-components/solution/SolSymbol';
import Orbit from './cesium-components/orbit/Orbit';

export default function Event() {
  let data_l1_jamming_init: Array<any> = [];
  let data_l2_jamming_init: Array<any> = [];
  let data_l1_spoofing_init: Array<any> = [];
  let layout_l1_jamming_init = {
    margin: {
      l: 100,
      r: 30,
      b: 40,
      t: 30,
      pad: 0,
    },
    height: 150,
    font: { color: 'white', family: 'Arial' },
    title: {
      text: 'Sensor Nodes L1 Jamming Events',
      font: {
        color: 'white',
        size: 12,
      },
    },
    xaxis: {
      title: {
        text: 'Time (UTC)',
        font: {
          color: 'white',
        },
      },
//      autorange: true,
      autorange: false,
      range: ['2025-01-01T00:00:00.000Z','2026-01-01T00:00:00.000Z'],
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    yaxis: {
      title: {
        text: '',
        font: {
          color: 'white',
        },
      },
      autorange: true,
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    shapes: [{}],
    plot_bgcolor: 'black',
    paper_bgcolor: 'black',
  };
  let layout_l2_jamming_init = {
    margin: {
      l: 100,
      r: 30,
      b: 40,
      t: 30,
      pad: 0,
    },
    height: 150,
    font: { color: 'white', family: 'Arial' },
    title: {
      text: 'Sensor Nodes L2 Jamming Events',
      font: {
        color: 'white',
        size: 12,
      },
    },
    xaxis: {
      title: {
        text: 'Time (UTC)',
        font: {
          color: 'white',
        },
      },
//      autorange: true,
      autorange: false,
      range: ['2025-01-01T00:00:00.000Z','2026-01-01T00:00:00.000Z'],
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    yaxis: {
      title: {
        text: '',
        font: {
          color: 'white',
        },
      },
      autorange: true,
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    shapes: [{}],
    plot_bgcolor: 'black',
    paper_bgcolor: 'black',
  };
  let layout_l1_spoofing_init = {
    margin: {
      l: 100,
      r: 30,
      b: 40,
      t: 30,
      pad: 0,
    },
    height: 150,
    font: { color: 'white', family: 'Arial' },
    title: {
      text: 'Sensor Nodes L1 Spoofing Events',
      font: {
        color: 'white',
        size: 12,
      },
    },
    xaxis: {
      title: {
        text: 'Time (UTC)',
        font: {
          color: 'white',
        },
      },
//      autorange: true,
      autorange: false,
      range: ['2025-01-01T00:00:00.000Z','2026-01-01T00:00:00.000Z'],
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    yaxis: {
      title: {
        text: '',
        font: {
          color: 'white',
        },
      },
      autorange: true,
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    shapes: [{}],
    plot_bgcolor: 'black',
    paper_bgcolor: 'black',
  };
  let data_error_init: Array<any> = [];
  let layout_error_init = {
    margin: {
      l: 100,
      r: 30,
      b: 40,
      t: 30,
      pad: 0,
    },
    height: 150,
    font: { color: 'white', family: 'Arial' },
    title: {
      text: 'Geolocation Precision (ECEF)',
      font: {
        color: 'white',
        size: 12,
      },
    },
    xaxis: {
      title: {
        text: 'Time (UTC)',
        font: {
          color: 'white',
        },
      },
      //      autorange: true,
      autorange: false,
      range: ['2025-01-01T00:00:00.000Z','2026-01-01T00:00:00.000Z'],
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    yaxis: {
      title: {
        text: 'Precision (km)',
        font: {
          color: 'white',
        },
      },
      autorange: true,
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    plot_bgcolor: 'black',
    paper_bgcolor: 'black',
  };
  const [data_sn_event_l1_jamming, setSNL1JammingEventData] = useState(data_l1_jamming_init);
  const [layout_sn_event_l1_jamming, setSNL1JammingEventLayout] = useState(layout_l1_jamming_init);
  const [data_sn_event_l2_jamming, setSNL2JammingEventData] = useState(data_l2_jamming_init);
  const [layout_sn_event_l2_jamming, setSNL2JammingEventLayout] = useState(layout_l2_jamming_init);
  const [data_sn_event_l1_spoofing, setSNL1SpoofingEventData] = useState(data_l1_spoofing_init);
  const [layout_sn_event_l1_spoofing, setSNL1SpoofingEventLayout] = useState(layout_l1_spoofing_init);
  const [data_error, setErrorData] = useState(data_error_init);
  const [layout_error, setErrorLayout] = useState(layout_error_init);
  
  let blank_report = 'assets/images/blankreport.png'
  const [sn1_report, setSN1Report] = useState(blank_report);
  const [sn2_report, setSN2Report] = useState(blank_report);
  const [sn3_report, setSN3Report] = useState(blank_report);
  const [sn4_report, setSN4Report] = useState(blank_report);
  let sn_info_init: Array<SNInfo> = [];
  const [sn_info, setSNInfo] = useState(sn_info_init);
  let aoa_info_init: Array<AOAEpochInfo> = [];
  const [aoa_info, setAOAInfo] = useState(aoa_info_init);
  let tdoa_info_init: Array<TDOAEpochInfo> = [];
  const [tdoa_info, setTDOAInfo] = useState(tdoa_info_init);
  let sol_info_init: Array<number[]> = [];
  const [sol_info, setSolInfo] = useState(sol_info_init);
  let orbit_info_init: Array<OrbitInfo> = [];
  const [orbit_info, setOrbitInfo] = useState(orbit_info_init);
  const [tle0, setTLE0] = useState('');
  const [tle1, setTLE1] = useState('');
  const [tle2, setTLE2] = useState('');
  
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [viewer, setViewer] = useState<Viewer | null>(null);

  // Update the window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define columns conditionally
  const dispatch = useDispatch();
  const layerData = useAppSelector((state) => state.layerData);
  const Events = layerData.event;

  useEffect(() => {
    const socket = io(window.location.host, {
      reconnectionDelayMax: 10000,
      path: '/api/socket',
      withCredentials: true,
      extraHeaders: {
        'Authorization': `Bearer ${TokenService.getToken()}`,
      }
    });
    socket!.emit('join', 'event');
    socket.on('event', (event: GristEvent) => {
      dispatch(actionUpdateLayerData('event', event) as any)
    });
    socket.io.on('reconnect', (attempt) => {
      socket!.emit('join', 'event');
    });
    return () => {
      socket!.emit('leave', '');
    };
  }, []);

  useEffect(() => {
console.log(Events);

    let layout_sn_event_l1_jamming_ = layout_sn_event_l1_jamming;
    let layout_sn_event_l2_jamming_ = layout_sn_event_l2_jamming;
    let layout_sn_event_l1_spoofing_ = layout_sn_event_l1_spoofing;
    if(Events.Time.length > 0) {
      var currentTime = new Date(Events.Time);
      var startTime = new Date();
      startTime.setDate(currentTime.getDate() - 30);
      var stopTime = new Date();
      stopTime.setDate(currentTime.getDate());
      layout_sn_event_l1_jamming_.xaxis.range = [startTime.toISOString(), stopTime.toISOString()];
      layout_sn_event_l2_jamming_.xaxis.range = [startTime.toISOString(), stopTime.toISOString()];
      layout_sn_event_l1_spoofing_.xaxis.range = [startTime.toISOString(), stopTime.toISOString()];
    }
    
    let data_sn_event_l1_jamming_: Array<any> = [];
    for(var i = 0; i < Events.SNEvent.L1Jammer.length; ++i) {
      let data_sn_event_x: Array<any> = [];
      let data_sn_event_y: Array<any> = [];
      data_sn_event_y.push(Events.SNEvent.L1Jammer[i].SN);
      data_sn_event_x.push('2000-01-01T00:00:00.000Z');
      for(var j = 0; j < Events.SNEvent.L1Jammer[i].StartTime.length; ++j) {
        data_sn_event_y.push(Events.SNEvent.L1Jammer[i].SN);
        data_sn_event_x.push(Events.SNEvent.L1Jammer[i].StartTime[j]);
      }
      data_sn_event_l1_jamming_.push({
        x: data_sn_event_x,
        y: data_sn_event_y,
        mode: 'markers',
        name: Events.SNEvent.L1Jammer[i].SN,
        line: {width: 3}
      });
    }    
    setSNL1JammingEventData(data_sn_event_l1_jamming_);
    layout_sn_event_l1_jamming_.title.text = 'Sensor Nodes L1 Jamming Events (last updated at ' + Events.Time + ')';
    layout_sn_event_l1_jamming_.shapes = [];
    for(var i = 0; i < Events.CommonEvent.L1Jammer.length; ++i) {
      var shape_l1_jamming = {
        type: 'rect',
        xref: 'x',
        yref: 'y',
        x0: Events.CommonEvent.L1Jammer[i].StartTime,
        y0: Events.SNEvent.L1Jammer[0].SN,
        x1: Events.CommonEvent.L1Jammer[i].StopTime,
        y1: Events.SNEvent.L1Jammer[Events.SNEvent.L1Jammer.length - 1].SN,
        fillecoler: 'rgba(255,0,0,0.2)',
        line: {
          color: 'red',
          width: 1,
          dash: 'solid'
        }
      };
      layout_sn_event_l1_jamming_.shapes.push(shape_l1_jamming);
    }
    setSNL1JammingEventLayout(layout_sn_event_l1_jamming_);
    
    let data_sn_event_l2_jamming_: Array<any> = [];
    for(var i = 0; i < Events.SNEvent.L2Jammer.length; ++i) {
      let data_sn_event_x: Array<any> = [];
      let data_sn_event_y: Array<any> = [];
      data_sn_event_y.push(Events.SNEvent.L2Jammer[i].SN);
      data_sn_event_x.push('2000-01-01T00:00:00.000Z');
      for(var j = 0; j < Events.SNEvent.L2Jammer[i].StartTime.length; ++j) {
        data_sn_event_y.push(Events.SNEvent.L2Jammer[i].SN);
        data_sn_event_x.push(Events.SNEvent.L2Jammer[i].StartTime[j]);
      }
      data_sn_event_l2_jamming_.push({
        x: data_sn_event_x,
        y: data_sn_event_y,
        mode: 'markers',
        name: Events.SNEvent.L2Jammer[i].SN,
        line: {width: 3}
      });
    }    
    setSNL2JammingEventData(data_sn_event_l2_jamming_);
    layout_sn_event_l2_jamming_.title.text = 'Sensor Nodes L2 Jamming Events (last updated at ' + Events.Time + ')';
    layout_sn_event_l2_jamming_.shapes = [];
    for(var i = 0; i < Events.CommonEvent.L2Jammer.length; ++i) {
      var shape_l2_jamming = {
        type: 'rect',
        xref: 'x',
        yref: 'y',
        x0: Events.CommonEvent.L2Jammer[i].StartTime,
        y0: Events.SNEvent.L2Jammer[0].SN,
        x1: Events.CommonEvent.L2Jammer[i].StopTime,
        y1: Events.SNEvent.L2Jammer[Events.SNEvent.L2Jammer.length - 1].SN,
        fillecoler: 'rgba(255,0,0,0.2)',
        line: {
          color: 'red',
          width: 1,
          dash: 'solid'
        }
      };
      layout_sn_event_l2_jamming_.shapes.push(shape_l2_jamming);
    }
    setSNL2JammingEventLayout(layout_sn_event_l2_jamming_);
    
    let data_sn_event_l1_spoofing_: Array<any> = [];
    for(var i = 0; i < Events.SNEvent.L1Spoofer.length; ++i) {
      let data_sn_event_x: Array<any> = [];
      let data_sn_event_y: Array<any> = [];
      data_sn_event_y.push(Events.SNEvent.L1Spoofer[i].SN);
      data_sn_event_x.push('2000-01-01T00:00:00.000Z');
      for(var j = 0; j < Events.SNEvent.L1Spoofer[i].StartTime.length; ++j) {
        data_sn_event_y.push(Events.SNEvent.L1Spoofer[i].SN);
        data_sn_event_x.push(Events.SNEvent.L1Spoofer[i].StartTime[j]);
      }
      data_sn_event_l1_spoofing_.push({
        x: data_sn_event_x,
        y: data_sn_event_y,
        mode: 'markers',
        name: Events.SNEvent.L1Spoofer[i].SN,
        line: {width: 3}
      });
    }    
    setSNL1SpoofingEventData(data_sn_event_l1_spoofing_);
    layout_sn_event_l1_spoofing_.title.text = 'Sensor Nodes L1 Spoofing Events (last updated at ' + Events.Time + ')';
    layout_sn_event_l1_spoofing_.shapes = [];
    for(var i = 0; i < Events.CommonEvent.L1Spoofer.length; ++i) {
      var shape_l1_spoofing = {
        type: 'rect',
        xref: 'x',
        yref: 'y',
        x0: Events.CommonEvent.L1Spoofer[i].StartTime,
        y0: Events.SNEvent.L1Spoofer[0].SN,
        x1: Events.CommonEvent.L1Spoofer[i].StopTime,
        y1: Events.SNEvent.L1Spoofer[Events.SNEvent.L1Spoofer.length - 1].SN,
        fillecoler: 'rgba(255,0,0,0.2)',
        line: {
          color: 'red',
          width: 1,
          dash: 'solid'
        }
      };
      layout_sn_event_l1_spoofing_.shapes.push(shape_l1_spoofing);
    }
    setSNL1SpoofingEventLayout(layout_sn_event_l1_spoofing_);    
  }, [Events.Time]);
  
  function findCommonEventIndex(sn: string, time: string, commonEvent: any) {
    var index = -1;
    let timeDate = new Date(time);
    for(var i = 0; i < commonEvent.length; ++i) {
      let startDate = new Date(commonEvent[i].StartTime);
      let stopDate = new Date(commonEvent[i].StopTime);
      if((timeDate >= startDate) &&
         (timeDate <= stopDate)) {
        index = i;
      }
    }
console.log('time', timeDate);
console.log('index', index);
    return index;
  }
  
  function findSNEventIndex(sn: string, time: string, snEvent: any) {
 /*   var index = {
      SNIndex: -1,
      EventIndex: -1
    };
    for(var i = 0; i < snEvent.length; ++i) {
      if(sn == snEvent[i].SN) {
        index.SNIndex = i;
      }
    }
    if((index.SNIndex >= 0) && (index.SNIndex < snEvent.length)) {
      for(var i = 0; i < snEvent[index.SNIndex].Event.length; ++i) {
        if((time == snEvent[index.SNIndex].Event[i].StartTime) ||
           (time == snEvent[index.SNIndex].Event[i].StopTime)) {
          index.EventIndex = i;
        }
      }
    }
    return index;*/
  }
  
  async function onClickDataPointL1Jamming(data: any) {
    var CommonEventIndex = findCommonEventIndex(data.points[0].data.y[data.points[0].pointIndex], data.points[0].data.x[data.points[0].pointIndex], Events.CommonEvent.L1Jammer);
    if(CommonEventIndex >= 0) {
      setSN1Report(blank_report);
      setSN2Report(blank_report);
      setSN3Report(blank_report);
      setSN4Report(blank_report);
      for(var i = 0; i < Events.CommonEvent.L1Jammer[CommonEventIndex].SN.length; ++i) {
        if(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Jammer[0].SN) {
          setSN1Report(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Jammer[1].SN) {
          setSN2Report(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Jammer[2].SN) {
          setSN3Report(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Jammer[3].SN) {
          setSN4Report(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i].ReportFile);
        }
      }
      
      sn_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Jammer[CommonEventIndex].SN.length; ++i) {
        sn_info_init.push(Events.CommonEvent.L1Jammer[CommonEventIndex].SN[i]);
      }
      setSNInfo(sn_info_init);
      aoa_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Jammer[CommonEventIndex].AOA.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L1Jammer[CommonEventIndex].AOA[i].AOA.length; ++j) {
          if(Events.CommonEvent.L1Jammer[CommonEventIndex].AOA[i].AOA[j].Valid) {
            aoa_info_init.push(Events.CommonEvent.L1Jammer[CommonEventIndex].AOA[i].AOA[j]);
          }
        }
      }
      setAOAInfo(aoa_info_init);
      tdoa_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Jammer[CommonEventIndex].TDOA.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L1Jammer[CommonEventIndex].TDOA[i].TDOA.length; ++j) {
          if(Events.CommonEvent.L1Jammer[CommonEventIndex].TDOA[i].TDOA[j].Valid) {
            tdoa_info_init.push(Events.CommonEvent.L1Jammer[CommonEventIndex].TDOA[i].TDOA[j]);
          }
        }
      }
      setTDOAInfo(tdoa_info_init);
      sol_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Jammer[CommonEventIndex].Sol.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L1Jammer[CommonEventIndex].Sol[i].Pos.length; ++j) {
          sol_info_init.push(Events.CommonEvent.L1Jammer[CommonEventIndex].Sol[i].Pos[j]);
        }
      }
      setSolInfo(sol_info_init);
      orbit_info_init = [];
      setTLE0('');
      setTLE1('');
      setTLE2('');
      for(var i = 0; i < Events.CommonEvent.L1Jammer[CommonEventIndex].Orbit.length; ++i) {
        orbit_info_init.push(Events.CommonEvent.L1Jammer[CommonEventIndex].Orbit[i]);
        setTLE0(Events.CommonEvent.L1Jammer[CommonEventIndex].Orbit[i].TLE[0].replace(/ /g, '\xa0'));
        setTLE1(Events.CommonEvent.L1Jammer[CommonEventIndex].Orbit[i].TLE[1].replace(/ /g, '\xa0'));
        setTLE2(Events.CommonEvent.L1Jammer[CommonEventIndex].Orbit[i].TLE[2].replace(/ /g, '\xa0'));
        /*
        let layout_error_ = layout_error;
        layout_error_.xaxis.range = [Events.CommonEvent.L1Jammer[CommonEventIndex].Error[0].Time, Events.CommonEvent.L1Jammer[CommonEventIndex].Error[Events.CommonEvent.L1Jammer[CommonEventIndex].Error.length - 1].Time];
        setErrorLayout(layout_error_);
        let data_error_: Array<any> = [];
        let data_error_time: Array<any> = [];
        let data_error_x: Array<any> = [];
        let data_error_y: Array<any> = [];
        let data_error_z: Array<any> = [];
        for(var i = 0; i < Events.CommonEvent.L1Jammer[CommonEventIndex].Error.length; ++i) {
          data_error_time.push(Events.CommonEvent.L1Jammer[CommonEventIndex].Error[i].Time);
          data_error_x.push(Events.CommonEvent.L1Jammer[CommonEventIndex].Error[i].IntegratedPrecision[0] / 1000.0);
          data_error_y.push(Events.CommonEvent.L1Jammer[CommonEventIndex].Error[i].IntegratedPrecision[1] / 1000.0);
          data_error_z.push(Events.CommonEvent.L1Jammer[CommonEventIndex].Error[i].IntegratedPrecision[2] / 1000.0);
        }
        data_error_.push({
          x: data_error_time,
          y: data_error_x,
          mode: 'lines',
          name: 'X',
          line: {width: 1}
        });  
        data_error_.push({
          x: data_error_time,
          y: data_error_y,
          mode: 'lines',
          name: 'Y',
          line: {width: 1}
        });  
        data_error_.push({
          x: data_error_time,
          y: data_error_z,
          mode: 'lines',
          name: 'Z',
          line: {width: 1}
        });  
        setErrorData(data_error_);
        */
      }
      setOrbitInfo(orbit_info_init);
    } else {
      setSN1Report(blank_report);
      setSN2Report(blank_report);
      setSN3Report(blank_report);
      setSN4Report(blank_report);
      setSNInfo([]);
      setAOAInfo([]);
      setTDOAInfo([]);
      setSolInfo([]);
      setOrbitInfo([]);
      setTLE0('');
      setTLE1('');
      setTLE2('');
    /*
      let layout_error_ = layout_error;
      layout_error_.xaxis.range = ['2000-01-01T00:00:00.000Z', '2000-01-01T00:00:00.000Z'];
      setErrorLayout(layout_error_);
      setErrorData([]);
    */
    }
  }
  
  async function onClickDataPointL2Jamming(data: any) {
    var CommonEventIndex = findCommonEventIndex(data.points[0].data.y[data.points[0].pointIndex], data.points[0].data.x[data.points[0].pointIndex], Events.CommonEvent.L2Jammer);
    if(CommonEventIndex >= 0) {
      setSN1Report(blank_report);
      setSN2Report(blank_report);
      setSN3Report(blank_report);
      setSN4Report(blank_report);
      for(var i = 0; i < Events.CommonEvent.L2Jammer[CommonEventIndex].SN.length; ++i) {
        if(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L2Jammer[0].SN) {
          setSN1Report(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L2Jammer[1].SN) {
          setSN2Report(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L2Jammer[2].SN) {
          setSN3Report(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].SN == Events.SNEvent.L2Jammer[3].SN) {
          setSN4Report(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i].ReportFile);
        }
      }
      
      sn_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L2Jammer[CommonEventIndex].SN.length; ++i) {
        sn_info_init.push(Events.CommonEvent.L2Jammer[CommonEventIndex].SN[i]);
      }
      setSNInfo(sn_info_init);
      aoa_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L2Jammer[CommonEventIndex].AOA.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L2Jammer[CommonEventIndex].AOA[i].AOA.length; ++j) {
          if(Events.CommonEvent.L2Jammer[CommonEventIndex].AOA[i].AOA[j].Valid) {
            aoa_info_init.push(Events.CommonEvent.L2Jammer[CommonEventIndex].AOA[i].AOA[j]);
          }
        }
      }
      setAOAInfo(aoa_info_init);
      tdoa_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L2Jammer[CommonEventIndex].TDOA.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L2Jammer[CommonEventIndex].TDOA[i].TDOA.length; ++j) {
          if(Events.CommonEvent.L2Jammer[CommonEventIndex].TDOA[i].TDOA[j].Valid) {
            tdoa_info_init.push(Events.CommonEvent.L2Jammer[CommonEventIndex].TDOA[i].TDOA[j]);
          }
        }
      }
      setTDOAInfo(tdoa_info_init);
      sol_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L2Jammer[CommonEventIndex].Sol.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L2Jammer[CommonEventIndex].Sol[i].Pos.length; ++j) {
          sol_info_init.push(Events.CommonEvent.L2Jammer[CommonEventIndex].Sol[i].Pos[j]);
        }
      }
      setSolInfo(sol_info_init);
      orbit_info_init = [];
      setTLE0('');
      setTLE1('');
      setTLE2('');
      for(var i = 0; i < Events.CommonEvent.L2Jammer[CommonEventIndex].Orbit.length; ++i) {
        orbit_info_init.push(Events.CommonEvent.L2Jammer[CommonEventIndex].Orbit[i]);
        setTLE0(Events.CommonEvent.L2Jammer[CommonEventIndex].Orbit[0].TLE[0].replace(/ /g, '\xa0'));
        setTLE1(Events.CommonEvent.L2Jammer[CommonEventIndex].Orbit[0].TLE[1].replace(/ /g, '\xa0'));
        setTLE2(Events.CommonEvent.L2Jammer[CommonEventIndex].Orbit[0].TLE[2].replace(/ /g, '\xa0'));
        /*
        let layout_error_ = layout_error;
        layout_error_.xaxis.range = [Events.CommonEvent.L2Jammer[CommonEventIndex].Error[0].Time, Events.CommonEvent.L2Jammer[CommonEventIndex].Error[Events.CommonEvent.L2Jammer[CommonEventIndex].Error.length - 1].Time];
        setErrorLayout(layout_error_);
        let data_error_: Array<any> = [];
        let data_error_time: Array<any> = [];
        let data_error_x: Array<any> = [];
        let data_error_y: Array<any> = [];
        let data_error_z: Array<any> = [];
        for(var i = 0; i < Events.CommonEvent.L2Jammer[CommonEventIndex].Error.length; ++i) {
          data_error_time.push(Events.CommonEvent.L2Jammer[CommonEventIndex].Error[i].Time);
          data_error_x.push(Events.CommonEvent.L2Jammer[CommonEventIndex].Error[i].IntegratedPrecision[0] / 1000.0);
          data_error_y.push(Events.CommonEvent.L2Jammer[CommonEventIndex].Error[i].IntegratedPrecision[1] / 1000.0);
          data_error_z.push(Events.CommonEvent.L2Jammer[CommonEventIndex].Error[i].IntegratedPrecision[2] / 1000.0);
        }
        data_error_.push({
          x: data_error_time,
          y: data_error_x,
          mode: 'lines',
          name: 'X',
          line: {width: 1}
        });  
        data_error_.push({
          x: data_error_time,
          y: data_error_y,
          mode: 'lines',
          name: 'Y',
          line: {width: 1}
        });  
        data_error_.push({
          x: data_error_time,
          y: data_error_z,
          mode: 'lines',
          name: 'Z',
          line: {width: 1}
        });  
        setErrorData(data_error_);
        */
      }
      setOrbitInfo(orbit_info_init);
    } else {
      setSN1Report(blank_report);
      setSN2Report(blank_report);
      setSN3Report(blank_report);
      setSN4Report(blank_report);
      setSNInfo([]);
      setAOAInfo([]);
      setTDOAInfo([]);
      setSolInfo([]);
      setOrbitInfo([]);
      setTLE0('');
      setTLE1('');
      setTLE2('');
      /*
      let layout_error_ = layout_error;
      layout_error_.xaxis.range = ['2000-01-01T00:00:00.000Z', '2000-01-01T00:00:00.000Z'];
      setErrorLayout(layout_error_);
      setErrorData([]);
      */
    }
  }
  
  async function onClickDataPointL1Spoofing(data: any) {
    var CommonEventIndex = findCommonEventIndex(data.points[0].data.y[data.points[0].pointIndex], data.points[0].data.x[data.points[0].pointIndex], Events.CommonEvent.L1Spoofer);
    if(CommonEventIndex >= 0) {
      setSN1Report(blank_report);
      setSN2Report(blank_report);
      setSN3Report(blank_report);
      setSN4Report(blank_report);
      for(var i = 0; i < Events.CommonEvent.L1Spoofer[CommonEventIndex].SN.length; ++i) {
        if(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Spoofer[0].SN) {
          setSN1Report(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Spoofer[1].SN) {
          setSN2Report(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Spoofer[2].SN) {
          setSN3Report(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].ReportFile);
        } else if(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].SN == Events.SNEvent.L1Spoofer[3].SN) {
          setSN4Report(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i].ReportFile);
        }
      }
      
      sn_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Spoofer[CommonEventIndex].SN.length; ++i) {
        sn_info_init.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].SN[i]);
      }
      setSNInfo(sn_info_init);
      aoa_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Spoofer[CommonEventIndex].AOA.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L1Spoofer[CommonEventIndex].AOA[i].AOA.length; ++j) {
          if(Events.CommonEvent.L1Spoofer[CommonEventIndex].AOA[i].AOA[j].Valid) {
            aoa_info_init.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].AOA[i].AOA[j]);
          }
        }
      }
      setAOAInfo(aoa_info_init);
      tdoa_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Spoofer[CommonEventIndex].TDOA.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L1Spoofer[CommonEventIndex].TDOA[i].TDOA.length; ++j) {
          if(Events.CommonEvent.L1Spoofer[CommonEventIndex].TDOA[i].TDOA[j].Valid) {
            tdoa_info_init.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].TDOA[i].TDOA[j]);
          }
        }
      }
      setTDOAInfo(tdoa_info_init);
      sol_info_init = [];
      for(var i = 0; i < Events.CommonEvent.L1Spoofer[CommonEventIndex].Sol.length; ++i) {
        for(var j = 0; j < Events.CommonEvent.L1Spoofer[CommonEventIndex].Sol[i].Pos.length; ++j) {
          sol_info_init.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].Sol[i].Pos[j]);
        }
      }
      setSolInfo(sol_info_init);
      orbit_info_init = [];
      setTLE0('');
      setTLE1('');
      setTLE2('');
      for(var i = 0; i < Events.CommonEvent.L1Spoofer[CommonEventIndex].Orbit.length; ++i) {
        orbit_info_init.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].Orbit[i]);
        setTLE0(Events.CommonEvent.L1Spoofer[CommonEventIndex].Orbit[0].TLE[0].replace(/ /g, '\xa0'));
        setTLE1(Events.CommonEvent.L1Spoofer[CommonEventIndex].Orbit[0].TLE[1].replace(/ /g, '\xa0'));
        setTLE2(Events.CommonEvent.L1Spoofer[CommonEventIndex].Orbit[0].TLE[2].replace(/ /g, '\xa0'));
        /*
        let layout_error_ = layout_error;
        layout_error_.xaxis.range = [Events.CommonEvent.L1Spoofer[CommonEventIndex].Error[0].Time, Events.CommonEvent.L1Spoofer[CommonEventIndex].Error[Events.CommonEvent.L1Spoofer[CommonEventIndex].Error.length - 1].Time];
        setErrorLayout(layout_error_);
        let data_error_: Array<any> = [];
        let data_error_time: Array<any> = [];
        let data_error_x: Array<any> = [];
        let data_error_y: Array<any> = [];
        let data_error_z: Array<any> = [];
        for(var i = 0; i < Events.CommonEvent.L1Spoofer[CommonEventIndex].Error.length; ++i) {
          data_error_time.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].Error[i].Time);
          data_error_x.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].Error[i].IntegratedPrecision[0] / 1000.0);
          data_error_y.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].Error[i].IntegratedPrecision[1] / 1000.0);
          data_error_z.push(Events.CommonEvent.L1Spoofer[CommonEventIndex].Error[i].IntegratedPrecision[2] / 1000.0);
        }
        data_error_.push({
          x: data_error_time,
          y: data_error_x,
          mode: 'lines',
          name: 'X',
          line: {width: 1}
        });  
        data_error_.push({
          x: data_error_time,
          y: data_error_y,
          mode: 'lines',
          name: 'Y',
          line: {width: 1}
        });  
        data_error_.push({
          x: data_error_time,
          y: data_error_z,
          mode: 'lines',
          name: 'Z',
          line: {width: 1}
        });  
        setErrorData(data_error_);
        */
      }
      setOrbitInfo(orbit_info_init);
    } else {
      setSN1Report(blank_report);
      setSN2Report(blank_report);
      setSN3Report(blank_report);
      setSN4Report(blank_report);
      setSNInfo([]);
      setAOAInfo([]);
      setTDOAInfo([]);
      setSolInfo([]);
      setOrbitInfo([]);
      setTLE0('');
      setTLE1('');
      setTLE2('');
    /*
      let layout_error_ = layout_error;
      layout_error_.xaxis.range = ['2000-01-01T00:00:00.000Z', '2000-01-01T00:00:00.000Z'];
      setErrorLayout(layout_error_);
      setErrorData([]);
      */
    }
  }

  return (
    <div className="Status" style={{ overflowX: "visible" }}>
      <div className="status-body">
        <Table>
          <TableBody>
            <TableRow>
              <TableCell
                style={{border: '1px solid rgba(0, 0, 0, 1)', width: "50%", backgroundColor: "black"}}
                padding="none"
              >
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "100%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <CesiumViewer callback={setViewer}>
                          <Compass />
                          {sn_info.map((sn, index) => (
                            <React.Fragment key={index}>
                              <SNSymbol
                                pos={sn.Pos}
                                size={10}
                              />
                              <SNLabel
                                label={sn.SN}
                                pos={sn.Pos}
                                size={0.4}
                              />
                            </React.Fragment>
                          ))}
                          {aoa_info.map((aoa, aoaIndex) => (
                            <AOA
                              pos={aoa.Pos}
                              azi={aoa.Azi}
                              ele={aoa.Ele}
                              range={1000000}
                              size={1}
                              color={[255,255,0,40]}
                            />
                          ))}
                          {tdoa_info.map((tdoa, tdoaIndex) => (
                            <TDOA
                              pos={tdoa.Pos}
                              delay={tdoa.Delay}
                              roll={tdoa.Roll}
                              size={1}
                              color={[255,0,155,40]}
                            />
                          ))}
                          {sol_info.map((sol, solIndex) => (
                            <SolSymbol
                              pos={sol}
                              size={8}
                            />
                          ))}
                          {orbit_info.map((orbit, orbitIndex) => (
                            <Orbit
                              pos={orbit.Pos}
                              size={3}
                              color={[255,0,0]}
                            />
                          ))}
                          {orbit_info.map((orbit, orbitIndex) => (
                            <Orbit
                              pos={orbit.OrbitPlane}
                              size={1}
                              color={[100,100,100]}
                            />
                          ))}
                          {orbit_info.map((orbit, orbitIndex) => (
                            <Orbit
                              pos={orbit.GroundTrack}
                              size={1}
                              color={[0,255,0]}
                            />
                          ))}
                        </CesiumViewer>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "100%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <Plot
                          data={data_sn_event_l1_jamming as any}
                          layout={layout_sn_event_l1_jamming}
                          useResizeHandler={true}
                          style={{ width: "100%", height: "100%" }}
                          onClick={(data) => onClickDataPointL1Jamming(data)}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "100%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <Plot
                          data={data_sn_event_l2_jamming as any}
                          layout={layout_sn_event_l2_jamming}
                          useResizeHandler={true}
                          style={{ width: "100%", height: "100%" }}
                          onClick={(data) => onClickDataPointL2Jamming(data)}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "100%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <Plot
                          data={data_sn_event_l1_spoofing as any}
                          layout={layout_sn_event_l1_spoofing}
                          useResizeHandler={true}
                          style={{ width: "100%", height: "100%" }}
                          onClick={(data) => onClickDataPointL1Spoofing(data)}
                        />
                      </TableCell>
                    </TableRow>                    
                  </TableBody>
                </Table>      
              </TableCell>
              <TableCell
                style={{border: '1px solid rgba(0, 0, 0, 1)', width: "50%", backgroundColor: "black"}}
                padding="none"
              >
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "50%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <img
                          src={sn1_report}
                          alt="SN Report 1"
                          height={480}
                        />
                      </TableCell>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "50%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <img
                          src={sn2_report}
                          alt="SN Report 2"
                          height={480}
                        />
                      </TableCell>
                    </TableRow> 
                    <TableRow>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "50%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <img
                          src={sn3_report}
                          alt="SN Report 3"
                          height={480}
                        />
                      </TableCell>
                      <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "50%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <img
                          src={sn4_report}
                          alt="SN Report 4"
                          height={480}
                        />
                      </TableCell>
                    </TableRow>          
                  </TableBody>
                </Table>    
              </TableCell>
            </TableRow>    
            <TableRow> 
              <TableCell
                        style={{border: '1px solid rgba(0, 0, 0, 1)', width: "60%", backgroundColor: "black"}}
                        padding="none"
                      >
                        <Table>
                          <TableBody>   
                            <TableRow>
                              <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', paddingTop: 2, paddingBottom: 0, color: 'white', fontFamily: 'Courier', fontSize:'24px'}}>
                                {tle0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', paddingTop: 2, paddingBottom: 0, color: 'white', fontFamily: 'Courier', fontSize:'24px'}}>
                                {tle1}
                              </TableCell>
                            </TableRow>  
                            <TableRow>
                              <TableCell style={{border: '1px solid rgba(0, 0, 0, 1)', paddingTop: 2, paddingBottom: 0, color: 'white', fontFamily: 'Courier', fontSize:'24px'}}>
                                {tle2}
                              </TableCell>
                            </TableRow>  
                          </TableBody> 
                        </Table>  
              </TableCell>
            </TableRow>                  
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
